import { pageData as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isMask: false,
        isFirstEdit: true,
        show: {
            detail: false,
            map: false,
            traffic: false,
        },
    },
    // getters,
    actions: {
        setIsLoading({ commit }, val) {
            commit(types.setIsLoading, val);
        },
        setIsFirstEdit({ commit }, val) {
            commit(types.setIsFirstEdit, val);
        },
        toggleShow({ commit, state }, { name, isShow, trafficKind }) {
            if (name === 'detail' && !isShow) {
                commit(types.setSpotId, '');
            }
            if (name === 'traffic') {
                commit(types.setTrafficKind, trafficKind || '');
            }
            if (isShow === undefined) {
                commit(types.setShowByKey, {
                    data: !state.show[name],
                    key: name,
                });
            } else {
                commit(types.setShowByKey, { data: isShow, key: name });
            }
        },
    },
    mutations: {
        [types.setIsLoading]: (state, data) => {
            state.isLoading = data;
        },
        [types.setIsFirstEdit]: (state, data) => {
            state.isFirstEdit = data;
        },
        [types.setShowByKey]: (state, { data, key }) => {
            if (key) {
                state.show[key] = data;
            }
        },
    },
};
